module.exports = __webpack_public_path__ + "978acda9701105cedb4f316a07f8bc3d.pdf";